<script>
//Line, Bar, Pie, Doughnut, HorizontalBar, Bubble, Scatter, PolarArea
import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ["chartData", "options"],
  mounted() {
    // this.chartData é criado no mixin.
    // Se você deseja passar opções, crie um objeto de opções locais
    this.renderChart(this.chartData, this.options);
  },
  
}
</script>


// WEBPACK FOOTER //
// src/views/Comum/Graficos/DoughnutChart.vue